/**
 * Collection of generic utility functions
 */
import { useRef } from 'react';

export default {
  /**
    * Custom react hook to debounce a callback function.
    * Only the last call is executed, the previous ones are debounced and canceled.
    *
    * @param [timeout] {number} The timeframe (in ms) in which all calls are debounced.
    */
  useDebouncedCallback(timeout = 0) {
    const ref = useRef(0);
    return (callback) => {
      ref.current = Date.now();
      setTimeout(() => {
        // if the difference is larger than timeout, that means
        // no other calls have been prompted, therefore execute callback
        if (Date.now() - ref.current >= timeout) {
          callback();
        }
      }, timeout);
    };
  },
  /**
   * Get Correct field classes based on formik value
   *
   * @param formik {object}
   * @param fieldKey {string}
   * @param classes {object}
   * @param isSelect {boolean}
   */
  getFieldClasses(formik, fieldKey, classes, isSelect = false) {
    const fieldClasses = [
      'mdl-textfield',
      'mdl-js-textfield',
    ];

    if (!isSelect) {
      fieldClasses.push('mdl-textfield--floating-label');
    }

    if (formik.values[fieldKey] !== '') {
      fieldClasses.push('is-dirty');
    }

    if (formik.errors[fieldKey] && formik.touched[fieldKey]) {
      fieldClasses.push(classes.isInvalid);
    }

    return fieldClasses.join(' ');
  },
  /**
   * Order alphabetic models
   * @param models {array}
   * @return {*[]}
   */
  sortModels: (models) => {
    const data = models.sort((modelA, modelB) => ((modelA.name > modelB.name) ? 1 : -1));
    const values = [];
    for (let i = 0; i < data.length; i += 1) {
      values.push({
        ...data[i],
        value: data[i].id,
        text: data[i].name,
      });
    }
    return values;
  },
  /**
   * Modify a price by range
   * @param priceRange {object} Price range object
   * @param price {number} Price to modify
   */
  quotePriceRange: (data, price) => {
    let correctPrice = price;
    Object.keys(data).forEach((key) => {
      const priceRange = data[key];
      const { ratio: priceRatio, price_from: priceFrom, price_to: priceTo } = priceRange;
      const priceSign = priceRange.sign ? priceRange.sign : '-';
      let rangeCorrect = parseInt(priceRange.correct, 10);

      if (priceFrom <= price && price < priceTo) {
        if (priceRatio === '€') {
          rangeCorrect = rangeCorrect < 0 ? 0 : rangeCorrect;
        } else if (priceRatio === '%') {
          if (rangeCorrect > 0 && rangeCorrect <= 100) {
            rangeCorrect *= (price / 100);
          }
        }
        if (priceSign === '+') {
          correctPrice += rangeCorrect;
        } else {
          correctPrice -= rangeCorrect;
        }
      }
    });
    return correctPrice < 0 ? 0 : correctPrice;
  },
};
